import { motion } from 'framer-motion';

interface OrbitalRingProps {
  size?: number;
  strokeWidth?: number;
  color?: string;
  opacity?: number;
  rotation?: number;
  animate?: boolean;
  className?: string;
}

export default function OrbitalRing({
  size = 300,
  strokeWidth = 2,
  color = '#006eb7',
  opacity = 40,
  rotation = 0,
  animate = true,
  className = ''
}: OrbitalRingProps) {
  return (
    <motion.div
      className={`absolute pointer-events-none ${className}`}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ 
        opacity: 1, 
        scale: 1,
        rotate: animate ? 360 : rotation
      }}
      transition={{ 
        opacity: { duration: 1 },
        scale: { duration: 1 },
        rotate: { duration: 60, repeat: Infinity, ease: 'linear' }
      }}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <defs>
          <linearGradient id={`orbital-gradient-${size}`} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={color} stopOpacity={opacity / 100} />
            <stop offset="50%" stopColor={color} stopOpacity={(opacity * 1.5) / 100} />
            <stop offset="100%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={size / 2 - strokeWidth}
          fill="none"
          stroke={`url(#orbital-gradient-${size})`}
          strokeWidth={strokeWidth}
          strokeDasharray="75 25"
          className="drop-shadow-lg"
        />
      </svg>
    </motion.div>
  );
}